var _excluded = ["cardNumber", "label", "showDetails", "onCopy", "data-testid"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useMemo } from 'react';
import { useTestId } from '../../../../utils';
import { BaseVirtualCardDetails } from './BaseVirtualCardDetails';
import { jsx as _jsx } from "react/jsx-runtime";
export var CardNumber = _ref => {
  var {
    cardNumber,
    label,
    showDetails = true,
    onCopy,
    'data-testid': dataTestId = 'card-number'
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var cardNumberToView = useMemo(() => {
    var cardNumberStringWithoutSpaces = cardNumber.toString().replace(/\s/g, '');
    var visibleChars = Math.min(cardNumberStringWithoutSpaces.length, 4);
    var maskedPart = '•'.repeat(cardNumberStringWithoutSpaces.length - visibleChars);
    var visiblePart = cardNumberStringWithoutSpaces.slice(-visibleChars);
    var cardNumberToParsing = showDetails ? cardNumberStringWithoutSpaces : maskedPart + visiblePart;
    return cardNumberToParsing.replace(/(.{4})/g, '$1 ');
  }, [cardNumber, showDetails]);
  var getTestId = useTestId(dataTestId);
  return /*#__PURE__*/_jsx(BaseVirtualCardDetails, _objectSpread(_objectSpread({
    "data-component": "BaseVirtualCard.CardNumber",
    mainLabel: cardNumberToView,
    label: "Card Number",
    onCopy: showDetails ? onCopy : undefined,
    enableCopy: showDetails,
    dataDogPrivacy: "mask"
  }, getTestId()), props));
};
CardNumber.displayName = 'BaseVirtualCard.CardNumber';
//# sourceMappingURL=CardNumber.js.map